import React, { useState, createContext, useContext } from "react";

// Create Context Object
const ResetZoomContext = createContext();

// Create a provider for components to consume and subscribe to changes
const ResetZoomProvider = (props) => {
	const [resetZoom, setResetZoom] = useState(false);

	return <ResetZoomContext.Provider value={[resetZoom, setResetZoom]}>{props.children}</ResetZoomContext.Provider>;
};

const useResetZoom = () => {
	const context = useContext(ResetZoomContext);
	if (context === undefined) {
		throw new Error('useResetZoom must be used within a ResetZoomProvider');
	}
	return context;
}

export { ResetZoomProvider, ResetZoomContext, useResetZoom }